import React, { useEffect, useState } from "react";

/**
 * Fixed-position light/dark toggle. Persists the choice in localStorage and
 * applies it via <html data-theme="dark">, which flips the CSS theme variables.
 * Rendered once at the app shell so it appears on every page.
 */
export function ThemeToggle() {
  const [dark, setDark] = useState(
    () =>
      typeof document !== "undefined" &&
      document.documentElement.getAttribute("data-theme") === "dark"
  );

  useEffect(() => {
    const theme = dark ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("bf-theme", theme);
    } catch (e) {
      /* localStorage unavailable */
    }
  }, [dark]);

  return (
    <button
      type="button"
      className="bf-theme-toggle"
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={() => setDark((d) => !d)}
    >
      <i className={dark ? "bi bi-sun-fill" : "bi bi-moon-stars-fill"}></i>
    </button>
  );
}

export default ThemeToggle;
